// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

.signInPage,
.signInPage .signInContainer,
.signInPage .signInContainer .signInFooter,
.signInPage .signInSection,
.signInPage .signInContainer .signInBtn {
  display: flex;
  width: 100%;
  align-items: center;
}

.signInPage {
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  justify-content: center;
  position: relative;
  z-index: 2011;
  background-color: white;
  /*providing bg-color white due to when bg-image loaded delay, visible spinner at background */
}

.signInPage .signInContainer {
  flex-direction: column;
  gap: 45px;
  width: 22.291vw;
  box-sizing: border-box;
  background-color: #ffff;
  border-radius: 25px;
  padding: 4.512vh 30px;
  text-align: center;
}

.martsonLogo {
  width: 13vw;
  padding-top: 3.147vh;
}

.signInPage .signInContainer .signInFooter {
  justify-content: center;
}

.signInPage .signInContainer .usernameTextBoxDiv {
  padding: 6px 0px;
  border-radius: 40px;
  border: 1px solid #838383;
  width: 100%;
}

.signInPage .signInSection {
  flex-direction: column;
  gap: 32px;
}

.reactSvgDiv.usernameIcon {
  height: 20px;
  width: 20px;
}

.signInPage .signInContainer .textbox .MuiInputBase-root {
  padding: 0px 24px;
  background-color: transparent;
}

.signInPage .signInContainer .textbox .MuiFormLabel-root {
  display: none;
}

/* giving direct value instead of variable(header-FontWeight, default-FontName) due to signInPage calls before App.js */
.signInPage .signInContainer .textbox .MuiInputBase-input::placeholder,
.signInPage .signInContainer .signInBtn,
.signInPage .signInContainer .signInFooterText,
.signInPage .signInContainer .textbox .MuiInputBase-root {
  font-family: Segoe UI;
  font-size: 16px;
  font-style: normal;
  letter-spacing: 0px;
  line-height: normal;
}

.signInPage .signInContainer .textbox .MuiInputBase-input::placeholder {
  color: #838383;
}

.signInPage .signInContainer .signInFooterText,
.signInPage .signInContainer .textbox .MuiInputBase-root {
  color: rgba(51, 51, 51, 0.8);
}

.signInPage .signInContainer .signInFooterText {
  font-weight: 600;
}

.signInPage .signInContainer .textbox .MuiInputBase-root,
.signInPage .signInContainer .textbox .MuiInputBase-input::placeholder {
  font-weight: 400;
}

.signInPage .signInContainer .signInBtn {
  height: 50px;
  border-radius: 50px;
  background-color: #1f3c88;
  justify-content: center;
  color: #ffff;
  cursor: pointer;
  box-shadow: 1px 8px 15px 1px rgba(0, 0, 0, 0.25);
}

.signInPage .signInContainer .signInBtn.enabled {
  opacity: 1;
  cursor: pointer;
}

.signInPage .signInContainer .signInBtn.disabled {
  opacity: 0.5;

  cursor: default;
  pointer-events: none;
}

@media screen and (max-width: 1366px) {
  .signInPage .signInContainer {
    width: 32.291vw;
  }

  .martsonLogo {
    width: 18vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/landingScreen/SignIn.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;;;;;EAKE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,6FAA6F;AAC/F;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA,uHAAuH;AACvH;;;;EAIE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,YAAY;;EAEZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n\n.signInPage,\n.signInPage .signInContainer,\n.signInPage .signInContainer .signInFooter,\n.signInPage .signInSection,\n.signInPage .signInContainer .signInBtn {\n  display: flex;\n  width: 100%;\n  align-items: center;\n}\n\n.signInPage {\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100%;\n  justify-content: center;\n  position: relative;\n  z-index: 2011;\n  background-color: white;\n  /*providing bg-color white due to when bg-image loaded delay, visible spinner at background */\n}\n\n.signInPage .signInContainer {\n  flex-direction: column;\n  gap: 45px;\n  width: 22.291vw;\n  box-sizing: border-box;\n  background-color: #ffff;\n  border-radius: 25px;\n  padding: 4.512vh 30px;\n  text-align: center;\n}\n\n.martsonLogo {\n  width: 13vw;\n  padding-top: 3.147vh;\n}\n\n.signInPage .signInContainer .signInFooter {\n  justify-content: center;\n}\n\n.signInPage .signInContainer .usernameTextBoxDiv {\n  padding: 6px 0px;\n  border-radius: 40px;\n  border: 1px solid #838383;\n  width: 100%;\n}\n\n.signInPage .signInSection {\n  flex-direction: column;\n  gap: 32px;\n}\n\n.reactSvgDiv.usernameIcon {\n  height: 20px;\n  width: 20px;\n}\n\n.signInPage .signInContainer .textbox .MuiInputBase-root {\n  padding: 0px 24px;\n  background-color: transparent;\n}\n\n.signInPage .signInContainer .textbox .MuiFormLabel-root {\n  display: none;\n}\n\n/* giving direct value instead of variable(header-FontWeight, default-FontName) due to signInPage calls before App.js */\n.signInPage .signInContainer .textbox .MuiInputBase-input::placeholder,\n.signInPage .signInContainer .signInBtn,\n.signInPage .signInContainer .signInFooterText,\n.signInPage .signInContainer .textbox .MuiInputBase-root {\n  font-family: Segoe UI;\n  font-size: 16px;\n  font-style: normal;\n  letter-spacing: 0px;\n  line-height: normal;\n}\n\n.signInPage .signInContainer .textbox .MuiInputBase-input::placeholder {\n  color: #838383;\n}\n\n.signInPage .signInContainer .signInFooterText,\n.signInPage .signInContainer .textbox .MuiInputBase-root {\n  color: rgba(51, 51, 51, 0.8);\n}\n\n.signInPage .signInContainer .signInFooterText {\n  font-weight: 600;\n}\n\n.signInPage .signInContainer .textbox .MuiInputBase-root,\n.signInPage .signInContainer .textbox .MuiInputBase-input::placeholder {\n  font-weight: 400;\n}\n\n.signInPage .signInContainer .signInBtn {\n  height: 50px;\n  border-radius: 50px;\n  background-color: #1f3c88;\n  justify-content: center;\n  color: #ffff;\n  cursor: pointer;\n  box-shadow: 1px 8px 15px 1px rgba(0, 0, 0, 0.25);\n}\n\n.signInPage .signInContainer .signInBtn.enabled {\n  opacity: 1;\n  cursor: pointer;\n}\n\n.signInPage .signInContainer .signInBtn.disabled {\n  opacity: 0.5;\n\n  cursor: default;\n  pointer-events: none;\n}\n\n@media screen and (max-width: 1366px) {\n  .signInPage .signInContainer {\n    width: 32.291vw;\n  }\n\n  .martsonLogo {\n    width: 18vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
